/** Read a small inline attachment, releasing its FileReader when sending is cancelled. */
export function readFileAsDataUrl(file: File, signal?: AbortSignal): Promise<string> {
  return new Promise((resolve, reject) => {
    signal?.throwIfAborted();
    const reader = new FileReader();
    const cleanup = () => signal?.removeEventListener("abort", onAbort);
    const fail = (error: unknown) => {
      cleanup();
      reject(error);
    };
    const onAbort = () => {
      reader.abort();
      fail(signal?.reason ?? new DOMException("Upload cancelled", "AbortError"));
    };
    reader.addEventListener(
      "load",
      () => {
        cleanup();
        if (typeof reader.result === "string") resolve(reader.result);
        else reject(new Error("Could not read image data."));
      },
      { once: true },
    );
    reader.addEventListener(
      "error",
      () => fail(reader.error ?? new Error("Failed to read image.")),
      { once: true },
    );
    reader.addEventListener(
      "abort",
      () => fail(signal?.reason ?? new DOMException("Upload cancelled", "AbortError")),
      { once: true },
    );
    signal?.addEventListener("abort", onAbort, { once: true });
    try {
      reader.readAsDataURL(file);
    } catch (error) {
      fail(error);
    }
  });
}
